import "./MergersAcquisitionsValueCreation.module.css";
import EnTete from "@/reusable_sections/Header";
import ServiceHero from "./sections/ServiceHero";
import ServiceDetails from "./sections/ServiceDetails";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function MergersAcquisitionsValueCreationPage() {
  return <div>
      <EnTete />
      <ServiceHero />
      <ServiceDetails />
      <CallToAction />
      <Footer />
    </div>;
}